module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av523-2d7538a8ff6993a9b3bba8e8e177497a.jpg";